import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '文章分类', path: '/category' },
    { label: '关于我们', path: '/about' },
  ],
  热门分类: [
    { label: '憋尿控制训练方法', path: '/category/bladder-control-training' },
    { label: '膀胱控制能力提升', path: '/category/bladder-capacity-improvement' },
    { label: '尿频改善方案', path: '/category/frequent-urination-solutions' },
  ],
  更多分类: [
    { label: '憋尿时间限制', path: '/category/urination-holding-limits' },
    { label: '膀胱训练技巧', path: '/category/bladder-training-techniques' },
    { label: '排尿控制健康指南', path: '/category/urination-control-health-guide' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <Link to="/" className="font-heading text-xl cursor-pointer hover:text-primary-400 transition-colors">
              膀胱健康管理
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              专业的膀胱健康科普平台，提供科学的憋尿控制训练方法与排尿健康管理方案，帮助您掌握健康的排尿管理策略。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-base mb-4 text-background-100">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 膀胱健康管理网. 保留所有权利.
          </p>
          <p className="text-xs text-background-400">
            本站内容仅供健康科普参考，不构成医疗诊断或治疗建议
          </p>
        </div>
      </div>
    </footer>
  );
}